const Authorizations = [
  { key: 'EnOcean', value: 'EnOcean' },
  { key: 'Profalux', value: 'Profalux' },
  { key: 'Rfxcom', value: 'Rfxcom' },
  { key: 'Zigbee', value: 'Zigbee' },
  { key: 'ZWave', value: 'ZWave' }
]

export default Authorizations
